import bbitApi from '@api/make-request'
import { IAcceptPupilIntoGroup } from '@app/interfaces/education/education-groups'

export function acceptPupilIntoGroup(data: IAcceptPupilIntoGroup) {
  return bbitApi.post('/education/api/v1/manual-education', data)
}
